import script from "./PricingPageTier.vue?vue&type=script&setup=true&lang=ts"
export * from "./PricingPageTier.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__